import { render, staticRenderFns } from "./weeklyList.vue?vue&type=template&id=683ad92c&scoped=true&"
import script from "./weeklyList.vue?vue&type=script&lang=js&"
export * from "./weeklyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683ad92c",
  null
  
)

export default component.exports